/*
 * DL資料 一覧 取得
 */
import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_LIST_DOCUMENT = 'API_GET_LIST_DOCUMENT';
/**
 * DL資料一覧 取得
 */
export const apiGetListDocument = ({ query: { page, themes } }, meta) => apiGetList(API_GET_LIST_DOCUMENT, `/document`, { page, themes }, Object.assign(Object.assign({}, meta), { isSnakeCase: true, requestPayload: { themes } }));
